import React from 'react'
import { useTranslation } from 'react-i18next'

import { useColumnToggle } from '../../../../hooks/useColumnToggle'
import { ConfigurableTable, convertOrder } from '../../../../utils/wrapper'
import { useAllDespatchAdvices } from '../../../despatch-advice/data'
import { useConfigContext } from '../../../ui-config/context'

const TOGGLEABLE_FIELDS = [
  'Payload.OrderDate',
  'Payload.ConfirmationId',
  'Payload.ConfirmationDate',
  'Payload.DeliveryType',
  'Payload.DeliveryDate',
]

const STORAGE_KEY = 'orders-despatch-advice-visible-columns'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
  isVisible: boolean
}

export const DespatchAdviceTable: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
  isVisible,
}) => {
  const { t } = useTranslation()

  const { data: despatchAdvices, isLoading } = useAllDespatchAdvices()
  const { uiConfig: config } = useConfigContext()

  const tableConfig = config.orders.despatchAdvice.table
  const { effectiveTableConfig, navigationColumnHeader } = useColumnToggle(
    tableConfig,
    TOGGLEABLE_FIELDS,
    STORAGE_KEY,
  )

  return (
    <div
      hidden={
        !isVisible &&
        (despatchAdvices === undefined || despatchAdvices.length === 0)
      }
    >
      {config.orders.despatchAdvice.enabled !== false && (
        <div className="mt-6">
          {<h3>{t('orders.despatchAdvice.title')}</h3>}

          <ConfigurableTable
            config={effectiveTableConfig}
            data={convertOrder(despatchAdvices)}
            link="orders/despatch-advice"
            globalFilterFields={['Payload.OrderId']}
            globalFilterValue={globalFilterValue}
            setGlobalFilterValue={setGlobalFilterValue}
            isLoading={isLoading}
            stateKey="table-despatch-advices"
            navigationColumnHeader={navigationColumnHeader}
          />
        </div>
      )}
    </div>
  )
}
